import FixedRatesEdit from './fixed-rates.edit';

export default {
  edit: FixedRatesEdit,
};
